export const logLoadPerf = (message: string): void => {
  if (typeof window !== 'undefined' && window.duckbillLogLoadPerf) {
    window.duckbillLogLoadPerf(message);
    return;
  }

  if (typeof performance === 'undefined') {
    // eslint-disable-next-line no-console
    console.info(`[duckbill:load] ${message}`);
    return;
  }

  // eslint-disable-next-line no-console
  console.info(`[duckbill:load] ${new Date().toISOString()} (+${Math.round(performance.now())}ms) ${message}`);
};
